import React, { useEffect, useState } from 'react';
import './BadgeNotification.css';

function BadgeNotification({ badge }) {
  const [show, setShow] = useState(true);

  useEffect(() => {
    // Auto-hide after 5 seconds
    const timer = setTimeout(() => {
      setShow(false);
    }, 5000);

    return () => clearTimeout(timer);
  }, []);

  if (!show) return null;

  return (
    <div className={`badge-notification ${show ? 'show' : ''}`}>
      <div className="badge-notification-content">
        <div className="badge-icon">🏆</div>
        <div className="badge-info">
          <div className="badge-title">Badge Unlocked!</div>
          <div className="badge-name-notif">{badge.name}</div>
        </div>
        <button
          className="badge-close"
          onClick={() => setShow(false)}
        >
          ×
        </button>
      </div>
    </div>
  );
}

export default BadgeNotification;
